import { Box, makeUclComponent } from '@rbilabs/universal-components';
import { ImageBackground } from 'react-native';

import { primitive } from 'styles/constants';

export const Wrapper = Box.withConfig<{
  $fullHeight?: boolean;
  $constrainToViewHeight?: boolean;
  $windowHeight?: number;
}>(({ $fullHeight, $constrainToViewHeight, $windowHeight, ...props }) => ({
  backgroundColor: primitive.$mayoEggWhite,
  ...($fullHeight && { height: '100%' }),
  ...($constrainToViewHeight && $windowHeight && { maxHeight: $windowHeight }),
  ...props,
}));

export const StyledImageBackground = makeUclComponent(ImageBackground).withConfig({
  height: '100%',
  width: '100%',
  flex: 1,
});
